export default __webpack_public_path__ + "static/media/shopping.5ceaf8b1.png";